<template>
  <div class="giftbox">
    <h2>中奖名单</h2>
    <div class="title">
      <span>中奖号码</span>
      <span>手机号</span>
      <span>奖项</span>
      <span>城市</span>
    </div>

    <div class="my-swipe">
      <vue-seamless-scroll :data="winnerList">
        <div class="item" v-for="(item, index) in winnerList" :key="index">
          <span>{{ item.number }}</span>
          <span>{{ shieldPhne(item.phone) }}</span>
          <span>{{ item.prize }}</span>
          <span>{{ item.dept }}</span>
        </div>
      </vue-seamless-scroll>
    </div>
    <!-- <van-swipe
      class="my-swipe"
      :autoplay="2000"
      :show-indicators="false"
      :loop="true"
      vertical
      :height="65"
      :touchable="false"
    >
      <van-swipe-item v-for="(item, index) in winnerList" :key="index">
        <div class="item">
          <span>{{ item.number }}</span>
          <span>{{ shieldPhne(item.phone) }}</span>
          <span>{{ item.prize }}</span>
          <span>{{ item.dept }}</span>
        </div>
      </van-swipe-item>
    </van-swipe> -->
  </div>
</template>

<script>
import { lotteryWinnerList } from "@/api/index";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      lotteryId: "1683689464171335681",
      winnerList: [],
      pageCount: 1,
    };
  },
  computed: {
    shieldPhne() {
      return (phone) => phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  created() {
    if (this.$route.query.lotteryId) {
      this.lotteryId = this.$route.query.lotteryId;
    }
    this.getWinnerList(1);
  },
  mounted() {
    setInterval(() => {
      this.winnerList = [];
      this.getWinnerList(1);
    }, 1000 * 60 * 10);
  },
  methods: {
    getWinnerList(page) {
      lotteryWinnerList({ lotteryId: this.lotteryId, limit: 11, page }).then(
        (res) => {
          const tempList = res?.page?.list || [];
          if (res.page.totalPage > page) {
            this.pageCount += 1;
            this.getWinnerList(this.pageCount);
          } else {
            this.pageCount = 1;
          }
          this.winnerList = [...this.winnerList, ...tempList];
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* prettier-ignore */
.giftbox {
    padding: 0 20PX;
    overflow: hidden;
  &>h2 {
    font-size: 30PX;
    font-weight: bold;
    color: #FFE970;
    background: linear-gradient(-90deg, #FFE970 0%, #FFB155 98.9990234375%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    margin-top: 38PX;
    margin-bottom: 0;
  }
  .title {
    color: #fff;
    display: flex;
    font-size: 16PX;
    line-height: 1;
    padding-top: 42PX;
    padding-bottom: 27PX;
    justify-content: space-around;
    span{
        // flex:1;
        text-align: center;
        max-width: 150PX;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        &:nth-child(1){
                min-width: 100PX;
            }
            &:nth-child(3){
                width: 80PX;
            }
            &:nth-child(4){
                width: 50PX;
            }
    }
  }
  .my-swipe{
    height: 700PX;
    overflow: hidden;
    .item{
        display: flex;
        color: #fff;
        font-size: 16PX;
        padding: 22PX 0;
        justify-content: space-around;
        span{
            text-align: center;
            // flex:1;
            max-width: 150PX;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &:nth-child(1){
                min-width: 100PX;
            }
            &:nth-child(3){
                width: 80PX;
            }
            &:nth-child(4){
                width: 50PX;
            }
        }
    }
  }
}
</style>
